/* TextColorHighlightMenu.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./TextColorHighlightMenu.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { textColorMessages as messages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette';
import { TextColorIcon, ToolbarColorSwatch, ToolbarDropdownMenu, ToolbarDropdownMenuProvider, ToolbarTooltip, getContrastingBackgroundColor, useToolbarUI } from '@atlaskit/editor-toolbar';
import { Box } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var styles = {
  menu: "_1rjcv77o _18zru2gc"
};
var getIconColor = function getIconColor(textColor, defaultColor, highlightColor) {
  if (highlightColor || !textColor || textColor === defaultColor && defaultColor) {
    return "var(--ds-text, #172B4D)";
  }
  return hexToEditorTextPaletteColor(textColor) || "var(--ds-text, #172B4D)";
};
export var TextColorHighlightMenu = function TextColorHighlightMenu(_ref) {
  var children = _ref.children,
    api = _ref.api;
  var isHighlightPluginExisted = !!(api !== null && api !== void 0 && api.highlight);
  var isTextColorDisabled = useSharedPluginStateSelector(api, 'textColor.disabled');
  var _useToolbarUI = useToolbarUI(),
    isToolbarDisabled = _useToolbarUI.isDisabled;
  var isDisabled = expValEquals('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? Boolean(isToolbarDisabled || isTextColorDisabled) : isTextColorDisabled;
  var highlightColor = useSharedPluginStateSelector(api, 'highlight.activeColor');
  var textColor = useSharedPluginStateSelector(api, 'textColor.color');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var defaultColor = useSharedPluginStateSelector(api, 'textColor.defaultColor');
  var iconColor = getIconColor(textColor, defaultColor, highlightColor);
  var highlightColorIcon = highlightColor ? highlightColor : getContrastingBackgroundColor(iconColor);
  return expValEquals('platform_editor_toolbar_aifc_patch_1', 'isEnabled', true) ? /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: formatMessage(isHighlightPluginExisted ? messages.textColorHighlightTooltip : messages.textColorTooltip)
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenuProvider, null, /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    iconBefore: /*#__PURE__*/React.createElement(ToolbarColorSwatch, {
      highlightColor: highlightColorIcon
    }, /*#__PURE__*/React.createElement(TextColorIcon, {
      label: formatMessage(messages.textColorTooltip),
      iconColor: iconColor,
      shouldRecommendSmallIcon: true,
      size: 'small',
      isDisabled: isDisabled,
      spacing: 'compact'
    })),
    isDisabled: isDisabled,
    testId: "text-color-highlight-menu",
    hasSectionMargin: false
  }, expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? children : /*#__PURE__*/React.createElement(Box, {
    xcss: styles.menu
  }, children)))) : /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    iconBefore: /*#__PURE__*/React.createElement(ToolbarColorSwatch, {
      highlightColor: highlightColorIcon
    }, /*#__PURE__*/React.createElement(TextColorIcon, {
      label: formatMessage(messages.textColorTooltip),
      iconColor: iconColor,
      shouldRecommendSmallIcon: true,
      size: 'small',
      isDisabled: isDisabled,
      spacing: 'compact'
    })),
    isDisabled: isDisabled,
    testId: "text-color-highlight-menu",
    hasSectionMargin: false
  }, expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? children : /*#__PURE__*/React.createElement(Box, {
    xcss: styles.menu
  }, children));
};